import { InputAdornment } from "@mui/material";
import { EmailIcon } from "Assets/icons";
import { Input } from "Components/Input";
import { forwardRef } from "react";
import { useIntl } from "react-intl";
import { AppInputProps } from "types/input";

const EmailInput = forwardRef<any, AppInputProps>(
  ({ toplabel, requiredlabel, ...props }, ref) => {
    const t = useIntl();
    return (
      <Input
        toplabel={toplabel}
        requiredlabel={requiredlabel}
        InputProps={{
          ...props.InputProps,
          startAdornment: (
            <InputAdornment position="start">
              <EmailIcon />
            </InputAdornment>
          ),
        }}
        placeholder={t.formatMessage({ id: "enter_your_email" })}
        ref={ref}
        {...props}
      />
    );
  }
);

export default EmailInput;
